module.exports = __webpack_public_path__ + "img/A911.4f9e744b.jpg";